import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {EditorComponent} from '@tinymce/tinymce-angular';
import {ExcRestService} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-note-edit',
  templateUrl: './modal-note-edit.component.html',
  styles: []
})
export class ModalNoteEditComponent extends ExcTranslation implements OnInit {
  @Input() data: any;
  note: any = {
    ntz_objID: '',
    ntzText: '',
    ntzRawText: '',
    ntz_enmIdent_NotizKlasse: 1,
    ntz_enmName_NotizKlasse: 'NotizKlasse'
  };
  initial: any = {};

  set content(value: string) {
    this.note.ntzText = value;
    this.note.ntzRawText = this.editor.editor.getContent({format: 'text'});
  }

  get content(): string {
    return this.note.ntzText;
  }

  MCEinit: any = {
    placeholder: 'Hier klicken um Notiztext einzugeben',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,
    readonly: 1,

    plugins: ['paste'],

    valid_styles: {
      '*': 'font-weight,font-style,text-decoration,text-align,color,background-color'
    },

    // beim Paste alle font-family/size hart entfernen
    paste_preprocess: (plugin: any, args: any) => {
      // args.content ist ein HTML-String
      args.content = args.content
        .replace(/font-family\s*:\s*[^;"']+;?/gi, '')
        .replace(/font-size\s*:\s*[^;"']+;?/gi, '')
        .replace(/<font[^>]*>/gi, '')
        .replace(/<\/font>/gi, '');
    },
    content_style:
      '@import url(\'https://fonts.googleapis.com/css?family=Calibri\'); body { font-family: Calibri; font-size: 11pt; }',

    toolbar:
      'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons',
    contextmenu: 'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons'
  };
  editMode = false;
  @ViewChild(EditorComponent) editor!: EditorComponent;

  get disabled(): boolean {
    if (this.editMode && this.note.ntzText === this.initial.ntzText) {
      return true;
    } else if (!this.editMode && this.note.ntzText === '') {
      return true;
    }
    return false;
  }

  constructor(public modal: ExgModalService,
              private excRestService: ExcRestService) {
    super();

  }

  keyupEvent = (event: any) => {
    if (event.keyCode === 27) {
      this.close();
    }
  }

  ngOnInit(): void {
    window.addEventListener('keyup', this.keyupEvent);
    if (this.data) {
      if (this.data.ntzID) {
        this.editMode = true;
        this.excRestService.get(this.excRestService.computeUrl('NoteR', {ntzID: this.data.ntzID})).subscribe((response: any) => {
          if (response.success) {
            this.note = response.data;
            this.initial = JSON.parse(JSON.stringify(this.note));
          }
        });
      } else {
        this.note.ntz_objID = this.data.ntz_objID;
        this.editMode = false;
      }
    }
  }

  close(): void {
    window.removeEventListener('keyup', this.keyupEvent);
    this.modal.close();
  }

  save(): void {
    ((!this.editMode) ?
      this.excRestService.post(this.excRestService.computeUrl('NoteC'), this.note)
      : this.excRestService.put(this.excRestService.computeUrl('NoteU', {ntzID: this.note.ntzID}), this.note))
      .subscribe((response) => {
        if (response.success) {
          this.modal.action(response.success);
        }
      });
  }
}


